import { SalesTaxFilingTasks } from '@commenda/types/src/sales-tax/types';
import IndirectTaxFilingWorkflowTask from './tasks/IndirectTaxFilingWorkflowTask';
import { ProvideCredentialsTask } from './tasks/ProvideCredentialsTask';

// Component Map
export const SALES_TAX_FILING_COMPONENT_MAP = {
  [SalesTaxFilingTasks.STATE_REGISTRATION]: ProvideCredentialsTask,
  [SalesTaxFilingTasks.GENERATE_FILING_REPORT]: IndirectTaxFilingWorkflowTask,
  [SalesTaxFilingTasks.REVIEW_TRANSACTIONS]: IndirectTaxFilingWorkflowTask,
  [SalesTaxFilingTasks.CONFIRM_FILING]: IndirectTaxFilingWorkflowTask,
};
